import { render } from "./OwnerCoursesDetails.vue?vue&type=template&id=2a5907be&scoped=true"
import script from "./OwnerCoursesDetails.vue?vue&type=script&lang=js"
export * from "./OwnerCoursesDetails.vue?vue&type=script&lang=js"

import "./OwnerCoursesDetails.vue?vue&type=style&index=0&id=2a5907be&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5907be"]])

export default __exports__